module.exports = __webpack_public_path__ + "media/newstyle/images/cta-mobile_de-adf69e6b5eec92307f054e7f20af39ec.png";